
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleSectionNavigation = (sectionId: string) => {
    navigate('/');
    setTimeout(() => scrollToSection(sectionId), 100);
  };

  const footerLinks = {
    services: [
      'Highway Design',
      'Drainage Design',
      'Estate Design',
      'Earthworks',
      'Project Support',
      'Technical Review'
    ],
    company: [
      'About Us',
      'Our Team'
    ]
  };

  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/501ecf28bb167b444bb1a5f14cdce300.png" 
                  alt="Vine Consulting Engineers Logo" 
                  className="w-10 h-10 object-contain"
                />
              </div>
              <div>
                <h3 className="text-lg font-bold">Vine Consulting Engineers</h3>
                <p className="text-sm" style={{ color: '#0B8D72' }}>Civil Engineering Consultants</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Professional civil engineering consultancy delivering sustainable and cost-effective solutions for the residential construction sector.
            </p>
          </div>

          {/* Services - Two Columns */}
          <div>
            <h4 className="text-base font-semibold mb-4">Our Services</h4>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              {footerLinks.services.map((service, index) => (
                <button 
                  key={index} 
                  onClick={() => handleSectionNavigation('services')}
                  className="text-gray-300 text-sm transition-colors cursor-pointer text-left hover:text-[#0B8D72]"
                >
                  {service}
                </button>
              ))}
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-base font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => handleSectionNavigation('about')}
                  className="text-gray-300 text-sm transition-colors cursor-pointer hover:text-[#0B8D72]"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/team')}
                  className="text-gray-300 text-sm transition-colors cursor-pointer hover:text-[#0B8D72]"
                >
                  Our Team
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h4 className="text-base font-semibold mb-4">Contact Information</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line text-sm" style={{ color: '#0B8D72' }}></i>
                <p className="text-white text-sm">+44(0) 7774 218 135</p>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line text-sm" style={{ color: '#0B8D72' }}></i>
                <p className="text-white text-sm">Mail@VineCE.co.uk</p>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-map-pin-line text-sm" style={{ color: '#0B8D72' }}></i>
                <p className="text-white text-sm">Alton, Hampshire, GU34 2UW</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
          <div>
            <p className="text-gray-400 text-sm">
              © {currentYear} Vine Consulting Engineers. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm mt-1">
              Registered in England and Wales. Company No: 12346799
            </p>
          </div>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <button 
              onClick={() => navigate('/privacy')}
              className="text-gray-400 text-sm transition-colors cursor-pointer hover:text-[#0B8D72]"
            >
              Privacy Policy
            </button>
            <button 
              onClick={() => navigate('/terms')}
              className="text-gray-400 text-sm transition-colors cursor-pointer hover:text-[#0B8D72]"
            >
              Terms of Service
            </button>
            <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-gray-400 text-sm transition-colors cursor-pointer hover:text-[#0B8D72]"
            >
              Website Builder
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}
